import WebFont from 'webfontloader';

const fonts = (families) => {
  if (WebFont) {
    WebFont.load({
      google: {
        families,
      },
    });
  }
};

const plugins = () => {
  const families = [
    'Caladea',
    'Minion Pro',
    'Oswald',
    'Roboto',
    'Roboto Condensed',
    'Frank Ruhl Libre',
    'Heebo',
    'Lato',
    'Rubik',
  ];

  fonts(families);
};

export default plugins;
